import {
  Button,
  CardContent,
  Paper,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import { navigate } from 'gatsby';
import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import routes from '../../routes';
import colors from '../../themes/main-colors';
import theme from '../../themes/theme';
import StartStopMoveIcon from '../../static/startStopMove.svg';

const useStyles = makeStyles(() =>
  createStyles({
    content: {
      display: 'flex',
      alignItems: 'center',
      padding: '20px',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    desc: {
      flex: '7',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },
    button: {
      color: colors.sparkBlue,
      background: 'transparent',
      borderColor: colors.sparkBlue,
      borderRadius: theme.spacing(3.75),
      minWidth: '100px',
      borderWidth: '2px',
      padding: '5px',
      width: '100%',
      '& span': {
        fontSize: '16px',
        [theme.breakpoints.down('sm')]: {
          fontSize: '18px',
        },
      },
      '&:hover': {
        color: colors.sparkBlue,
        background: 'transparent',
        borderColor: colors.sparkBlue,
        borderWidth: '2px',
      },
    },
    alignCenter: {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginTop: '1rem',
      },
    },
    icon: {
      flex: '1',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        marginBottom: '1rem',
      },
    },
  }),
);

export const SSMDashboardCard = () => {
  const { t, inlineRichT } = useTranslation();
  const classes = useStyles();
  return (
    <Paper>
      <CardContent className={classes.content}>
        <div className={classes.icon}>
          <StartStopMoveIcon />
        </div>
        <div className={classes.desc}>
          <Typography>{inlineRichT('DO_YOU_NEED_TO_SSM_SERVICE')}</Typography>
        </div>
        <div className={classes.alignCenter}>
          <Button
            variant="outlined"
            className={classes.button}
            onClick={() => void navigate(routes.START_STOP_MOVE)}
          >
            {t('MANAGE_YOUR_SERVICE')}
          </Button>
        </div>
      </CardContent>
    </Paper>
  );
};
